
import { h, Fragment, render } from 'preact'
import { useState, useRef } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { useLocalStorage } from './hooks/useLocalStorage'
import { useVisible } from './hooks/useVisible'
import { SavedJobsButton } from './components/SavedJobsButton.jsx'
import { Heart } from './components/Icon.jsx'
import { Button, IconButton } from './components/Button.jsx'
import classnames from 'classnames'
import { json } from './utility/dom'
import { filter } from './utility/object'



export default function init() {
	

	const element = document.getElementById('saved-jobs-menu')
	const singleComponents = [...document.querySelectorAll('.js-saved-jobs-button-component')]
	const { searchUrl } = json('#site-settings')

	element && render(createPortal(<SavedJobsMenu searchUrl={searchUrl} />, element), element)

	singleComponents.map(el => {
		const id = el.getAttribute('data-id')
		const title = el.getAttribute('data-title')
		const subtitle = el.getAttribute('data-subtitle')
		const href = el.getAttribute('data-href')
		const variant = el.getAttribute('data-variant')
		render(createPortal(<SavedJobsSingleButton id={id} title={title} subtitle={subtitle} href={href} variant={variant} />, el), el)
	})
}


function SavedJobsSingleButton({ id, title, subtitle, href, variant }) {
	const [savedJobs, setSaved] = useLocalStorage('savedJobs', {})
	const saved = savedJobs[id] || false
	const save = () => setSaved({
		...savedJobs, 
		[id]: { id, title, subtitle, href } 
	})
	const unsave = () => setSaved({
		...savedJobs,
		[id] : undefined
	})

	return <SavedJobsButton 
		variant={variant || 'outline'} 
		iconRight={Heart} 
		saved={saved} 
		save={save} 
		unsave={unsave} 
	/>
}


function SavedJobsMenu({ searchUrl }) {

	const [savedJobs, setSaved] = useLocalStorage('savedJobs', {})
	const jobArray = Object.values(savedJobs).filter(Boolean)
	const remove = id => setSaved(filter({...savedJobs, [id] : undefined }))
	const { ref, visible, setVisible } = useVisible(false)

	const count = jobArray.length > 0 && <span class="saved-jobs-button__number">({jobArray.length})</span>
	
	return <div ref={ref}>
		<Button 
			class="show@site-nav-breakpoint" 
			variant="ghost bold"
			iconLeft={Heart}
			onClick={() => setVisible(!visible)}>
			Saved jobs {count}
		</Button>

		<Button 
			class="hide@site-nav-breakpoint" 
			variant="ghost narrow"
			iconLeft={Heart}
			onClick={() => setVisible(!visible)}>
			{count}
		</Button>

		{visible && <>
			<div class="saved-jobs-menu__dropdown">
				{jobArray.length > 0 && <>
					<ul class="action-list">
						{jobArray.map(job => <Job savedJobs={savedJobs} onRemove={remove} {...job} />)}
					</ul>
				</> || <>
					<div class="text-center">
						No saved jobs found<br />
						<small><a href={searchUrl}>Search for roles</a></small>
					</div>
				</>}
			</div>
		</>}
	</div>
}


function Job({ id, title, subtitle, href, savedJobs, onRemove }) {

	const saved = savedJobs[id] || false

	return <div class="action-row">
		<div class="action-row__main">
			<a href={href} class="action-row__title">{title}</a>
			<div class="action-row__subtitle">{subtitle}</div>
		</div>
		<div class="action-row__actions">
			<SavedJobsButton size="small" icon iconRight={Heart} variant="ghost" saved={saved} unsave={() => onRemove(id)} />
		</div>
	</div>
}